import {CityProps, translatedCityProps} from 'modules/cities/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface NeighborhoodProps {
  id: string;
  name: string;
  active: boolean;
  deliveryPrice?: number;
  deliveryManFee?: number;
  city: CityProps;
  cityId: string;
}

export const translatedNeighborhoodProps: TranslatedKeys<NeighborhoodProps> = {
  name: 'Nome',
  active: 'Ativo?',
  cityId: 'Cidade',
  city: {...translatedCityProps, name: 'Cidade'},
  deliveryPrice: 'Taxa de entrega',
  deliveryManFee: 'Taxa do entregador',
};
